import { exportIMG } from '~core';
import { getMetadata } from '~loader/loader-utils';
import slugify from 'slugify';
import { getState } from '~src/state';
import { addWatermark, cleanBase64 } from '../utils';
import { getUser } from '~src/user';
import Swal from 'sweetalert2';
import JSZip from 'jszip';
import { getSelectedPagesByUser } from './getSelectedPagesByUser';
import { getImageFromPage } from './getImageFromPage';
import { saveAs } from 'file-saver';

export const savePNG = async () => {
  const metadata = getMetadata();
  const { user } = await getUser();
  const project = getState('selected.tipo');
  const selectedPagesByUser = getSelectedPagesByUser();

  const fileName = slugify(
    `${metadata.projectTypeName}${
      metadata.templatesCategoryName ? `-${metadata.templatesCategoryName}` : ''
    }${metadata.servizioName ? `-${metadata.servizioName}` : ''}${
      metadata.formatName ? `-${metadata.formatName}` : ''
    }`
  );

  const numberOfPages = selectedPagesByUser.length;

  if (numberOfPages === 1) {
    const { base64: image } = exportIMG(
      1,
      project.outputDpi,
      'base64',
      'png',
      false,
      project.multiplier || 1
    );
    if (user.org_pointer.tipo_istanza === 'demo') {
      Swal.fire({
        text: "Sto generando l'immagine...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const imageWithWatermark = await addWatermark(image);
      saveAs(imageWithWatermark, fileName + '.png');
      Swal.hideLoading();
      Swal.fire({
        title: 'Fatto!',
        html: "L'immagine &egrave; stata scaricata.",
        icon: 'success',
        confirmButtonColor: '#278e8e',
      });
    } else {
      saveAs(image, fileName + '.png');
      Swal.fire({
        title: 'Fatto!',
        html: "L'immagine &egrave; stata scaricata.",
        icon: 'success',
        confirmButtonColor: '#278e8e',
      });
    }

    return;
  }

  const zip = new JSZip();
  const folder = zip.folder('Cartella ' + fileName);

  let pageNumber = 0;
  for (let page of selectedPagesByUser) {
    pageNumber++;

    let image = await getImageFromPage(page);

    if (user.org_pointer.tipo_istanza === 'demo') {
      Swal.fire({
        text: 'Sto generando la cartella zip...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      image = await addWatermark(image);
      const base64Cleaned = cleanBase64(image);
      image = base64Cleaned.base64;
    }

    folder.file(`Pagina ${pageNumber}.png`, image, { base64: true });
  }
  const content = await zip.generateAsync({ type: 'blob' });
  saveAs(content, fileName + '.zip');
  Swal.hideLoading();
  Swal.fire({
    title: 'Fatto!',
    html: 'La cartella zip &egrave; stata scaricata.',
    icon: 'success',
    confirmButtonColor: '#278e8e',
  });
};
